import React from 'react'
import { useNavigate } from 'react-router-dom'

const ComingSoon = () => {
  const navigate = useNavigate()
  return (
    <div className="container mx-auto p-4 max-w-3xl">

      {/* Hero */}
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold font-serif mb-4">Where Backlog Explorer Is Heading in 2026</h1>
        <p className="text-xl text-base-content/70">
          A honest look at the direction, what's changing, and why.
        </p>
      </div>

      {/* Origin Story */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold font-serif mb-4">What Backlog Explorer Was Always Meant to Be</h2>
        <p className="text-base-content/80 leading-relaxed mb-4">
          Backlog Explorer started with one simple idea: help people reconnect with the games they
          already own instead of chasing the next purchase. Not productivity. Not gamification.
          Just that quiet moment of realizing — oh right, I actually wanted to play this.
        </p>
        <p className="text-base-content/80 leading-relaxed">
          That impulse to buy something new when there's a backlog full of great games you were
          once genuinely excited about — that's the problem worth solving. And it doesn't need a
          complex system. It needs a good nudge at the right moment.
        </p>
      </div>

      {/* Honest Drift */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold font-serif mb-4">Where Things Drifted</h2>
        <p className="text-base-content/80 leading-relaxed mb-4">
          Over time, features crept in. Journaling. Screenshots. Mood tracking sliders.
          A roadmap full of social features and seasonal suggestions. None of it was bad —
          but it started pulling Backlog Explorer away from what it was meant to do.
        </p>
        <p className="text-base-content/80 leading-relaxed">
          That drift wasn't a mistake so much as a detour. This year, I'm finding my way back.
        </p>
      </div>

      {/* Two Focus Areas */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold font-serif mb-6">What I'm Focusing On</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          <div className="card bg-base-200 shadow-xl hover:shadow-2xl transition-shadow">
            <div className="card-body">
              <div className="text-4xl mb-4">🚀</div>
              <h3 className="card-title">Effortless Import</h3>
              <p className="text-base-content/70">
                Getting your library in should take seconds, not sessions. Fast Steam imports,
                smart filtering to skip the noise, and zero friction from sign-up to your actual backlog.
              </p>
              <div className="card-actions justify-end mt-4">
                <div className="badge badge-outline">In Focus</div>
              </div>
            </div>
          </div>

          <div className="card bg-base-200 shadow-xl hover:shadow-2xl transition-shadow">
            <div className="card-body">
              <div className="text-4xl mb-4">🎯</div>
              <h3 className="card-title">Recommendations That Feel Right</h3>
              <p className="text-base-content/70">
                Not sliders and settings — just a recommendation that makes you go "oh yeah, that one."
                Matching by vibe, genre, and theme to surface games you'll actually want to play tonight.
              </p>
              <div className="card-actions justify-end mt-4">
                <div className="badge badge-outline">In Focus</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* What This Means */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold font-serif mb-4">What This Means for the App</h2>
        <p className="text-base-content/80 leading-relaxed mb-4">
          Fewer features, more depth. Some things on the old roadmap won't happen — at least not now.
          What's here will get better: faster, more reliable, and more useful for the core loop
          of picking up a game from your existing library.
        </p>
        <p className="text-base-content/80 leading-relaxed">
          The goal isn't to be everything. It's to be the thing that actually gets you playing.
        </p>
      </div>

      {/* Data Reassurance */}
      <div className="card bg-base-200 mb-12">
        <div className="card-body">
          <h3 className="card-title mb-2">Your data isn't going anywhere</h3>
          <p className="text-base-content/70">
            Existing notes, journal entries, and library data all stay exactly as they are.
            Refocusing the product doesn't mean wiping the slate — everything you've added
            will still be there.
          </p>
        </div>
      </div>

      {/* Thank You */}
      <div className="mb-16 text-base-content/80 leading-relaxed">
        <p className="mb-4">
          Thanks for being here during this chapter. Whether you signed up early or found this
          recently — your presence and feedback have shaped what Backlog Explorer is becoming.
        </p>
        <p>
          Here's to spending more time playing games we already love, and less time buying ones we won't get to.
        </p>
      </div>

      {/* Feedback Button */}
      <div className="max-w-2xl mx-auto mb-16">
        <div className="bg-base-200 p-6 rounded-lg flex flex-col items-center shadow-lg">
          <h3 className="text-2xl font-bold font-serif mb-2">Got thoughts?</h3>
          <p className="mb-4 text-base-content/70 text-center">
            Ideas, requests, bugs — all of it is useful right now. Send it through.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/app/feedback')}
          >
            Send feedback
          </button>
        </div>
      </div>

    </div>
  )
}

export default ComingSoon
